import React from 'react';

const BookMarkSolidIcon = (props) => {
  return (
    <svg aria-hidden="true" id={props.id} height={props.height} width={props.width} focusable="false" data-prefix="fas" data-icon="bookmark" className="svg-inline--fa fa-bookmark fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill={props.color} d="M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z" /></svg>
  );
};

export default BookMarkSolidIcon;
